<template>
  <div>
    <alert-component :id="id"/>
  </div>
</template>

<script>
  import AlertComponent from '@/components/AlertComponent';

  export default {
    name: 'Alert',
    components: {
      AlertComponent
    },
    data() {
      return {
        id: this.$route.params.id
      };
    },
  };
</script>

